import city from "./city.component";
import cityUrls from "./city.urls";
import CityTransforms from "./city.transforms";

const cityModule = angular
  .module("app.components.city", [])
  .component("cityPage", city)
  .service("CityTransforms", CityTransforms)
  .config(cityUrls);

export default cityModule;



// WEBPACK FOOTER //
// ./src/pages/city/city.module.js